module.exports = __webpack_public_path__ + "img/25761bad-f73c-436d-bc07-670cf37d7270.002.8e4c9e4e.png";